export default class UiDateUtils {
  static formattedDate(date) {
    return date === undefined || date === null ? "" : date.split("-").join("/");
  }

  static formatYYYYMMDDToEUWithoutTime(date) {
    if (date) {
      date = date.split("T")[0];
      if (date) {
        const dates = date.split("-");
        return dates[2] + "/" + dates[1] + "/" + dates[0];
      } else return "";
    } else return "";
  }

  static formatDateYYYYMMDD(year, month, day) {
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    const formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
  }

  static formatDateDDMMYYYWithOutDashes(year, month, day) {
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    const formattedDate = day.toString() + month.toString() + year.toString();
    return formattedDate;
  }

  static saveDateFormat(date) {
    return date === null ? "" : date.split("/").join("-");
  }

  static formatDateddmmyyyy(str) {
    if (typeof str === "undefined" || str === null) {
      return "Not Specified";
    }
    return (str = str.slice(0, 2) + "/" + str.slice(2, 4) + "/" + str.slice(4));
  }

  static formatDateDDMMYYYY(date) {
    return (
      date &&
      ("0" + date.getDate()).slice(-2) +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        date.getFullYear()
    );
  }

  static formatTodayDate(str) {
    const year = str.substring(0, 4);
    const month = str.substring(5, 7);
    const day = str.substring(8, 10);
    return new Date(year, month - 1, day);
  }

  static addDays(days) {
    const today = new Date();
    return today.setDate(today.getDate() + days);
  }

  static addMonths(months) {
    const today = new Date();
    return today.setMonth(today.getMonth() + months);
  }

  static formatyyyymmddTOddmmyyyy(dateStr, currentSeparator, newSeperator) {
    if (dateStr) {
      const dates = dateStr.split(currentSeparator);
      if (dates.length === 3)
        return dates[2] + newSeperator + dates[1] + newSeperator + dates[0];
    }
    return null;
  }

  static formatDateDDMMYYYYToYYYYMMDD(dateStr, currentSeparator, newSeparator) {
    if (dateStr) {
      const dates = dateStr.split(" ")[0].split(currentSeparator);
      if (dates.length === 3)
        return dates[2] + newSeparator + dates[1] + newSeparator + dates[0];
    }
    return null;
  }

  static isAValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }
}
